//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
// import EmpresaFinanceiroEdit from './EmpresaFinanceiroEdit';
import EmpresaFinanceiroListagemPage from './EmpresaFinanceiroListagemPage';
import EmpresaFinanceiroView from './EmpresaFinanceiroView';

export default class EmpresaFinanceiroIndex extends React.Component<{}> {
  render() {
    return (
      <Switch>
        <Route path="/empresaFinanceiro" component={EmpresaFinanceiroListagemPage} exact />
        {/* <Route path="/empresaFinanceiro/novo" component={EmpresaFinanceiroEdit} /> */}
        <Route path="/empresaFinanceiro/view/:id" component={EmpresaFinanceiroView} />
      </Switch>
    );
  }
}
